var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockchainIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 81,
    viewBox: "0 0 85 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 49.5106L18.051 58.5418V80.5218L0 71.4984V49.5106ZM22.051 80.5226L40.102 71.4992V49.5112L22.051 58.5307V80.5226ZM20.0432 37.4796L2.4732 46.2687L20.0512 55.0578L37.6292 46.2687L20.0432 37.4796ZM44.1022 71.4996L62.1532 80.5191V58.5311L44.1022 49.5116V71.4996ZM66.1532 58.5426V80.5226L84.2042 71.5031V49.5111L66.1532 58.5426ZM64.161 37.4806L46.571 46.2697L64.149 55.0588L81.727 46.2697L64.161 37.4806ZM22.052 34.0118L40.103 43.043V21.051L22.052 12.0198V34.0118ZM44.103 43.043L62.154 34.0118V12.0238L44.103 21.0511V43.043ZM42.103 0L24.525 8.7891L42.103 17.5821L59.681 8.793L42.103 0Z",
    fill: "#484B53",
    fillOpacity: 0.46
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchainIcon);
export default __webpack_public_path__ + "static/media/blockchain-icon.84b74696737ba1acfb2964c83d2d4a33.svg";
export { ForwardRef as ReactComponent };